/**
 * The GL posting-governance route table (design C3 §5.9, §6.6).
 *
 * Exported as `GL_GOVERNANCE_ROUTES` and mounted by **P9** in
 * `web/src/router/index.ts`. The pre-C3 GL screens (journal entries, the ledger,
 * the three statements) are already mounted there and are untouched by this
 * file — the two sets are separate exports so P9 merges one and rewrites
 * nothing.
 */

import type { RouteRecordRaw } from 'vue-router'

import { GL_PERMISSIONS } from '@/modules/gl/permissions'
import { GL_FT6_REPORT_ROUTES } from '@/modules/gl/reports/routes'

export const GL_GOVERNANCE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/gl/journal-types',
    name: 'gl-journal-types',
    component: () => import('@/modules/gl/JournalTypesView.vue'),
    meta: {
      titleKey: 'gl.routeTitles.journalTypes',
      permission: GL_PERMISSIONS.journalTypeRead
    },
  },
  {
    path: '/gl/dimension-policies',
    name: 'gl-dimension-policies',
    component: () => import('@/modules/gl/DimensionPoliciesView.vue'),
    meta: {
      titleKey: 'gl.routeTitles.dimensionPolicies',
      permission: GL_PERMISSIONS.accountRead
    },
  },
  {
    path: '/gl/suspense',
    name: 'gl-suspense',
    component: () => import('@/modules/gl/SuspenseView.vue'),
    meta: {
      titleKey: 'gl.routeTitles.suspense',
      permission: GL_PERMISSIONS.suspenseRead
    },
  },
  {
    path: '/gl/accruals',
    name: 'gl-accruals',
    component: () => import('@/modules/gl/AccrualsView.vue'),
    meta: {
      titleKey: 'gl.routeTitles.accruals',
      permission: GL_PERMISSIONS.accrualRead
    },
  },
  {
    path: '/gl/posting-assertions',
    name: 'gl-posting-assertions',
    component: () => import('@/modules/gl/PostingAssertionsView.vue'),
    meta: {
      titleKey: 'gl.routeTitles.assertions',
      permission: GL_PERMISSIONS.assertionRead
    },
  },

  // FT6-U14 (FSD 2.2.1.11): the journal register, manual journal analysis and cash-flow
  // statement live in their own file so the wave's routes are reviewable as a block; the
  // router still imports one array. None of these paths exists in router/index.ts.
  ...GL_FT6_REPORT_ROUTES,
]
